import React, { useState, useEffect } from 'react';
import { Moon, Sun, Instagram, Phone, MessageCircle } from 'lucide-react';
import { useNavigate } from "react-router-dom";

const Portfolio = () => {
  const [isDark, setIsDark] = useState(true);
 const navigate = useNavigate();
  const codeSnippets = [
    { lang: 'Flutter', code: 'Widget build(BuildContext context) {\n  return MaterialApp(\n    home: Scaffold(\n      body: Center(\n        child: Text("Hello"),\n      ),\n    ),\n  );\n}' },
    { lang: 'Laravel', code: 'Route::get("/api/users", function() {\n  return User::all();\n});\n\n$users = DB::table("users")\n  ->where("active", true)\n  ->get();' },
    { lang: 'React', code: 'const App = () => {\n  const [state, setState] = useState(0);\n  \n  useEffect(() => {\n    console.log("Mounted");\n  }, []);\n  \n  return <div>{state}</div>;\n};' },
    { lang: 'Python', code: 'def calculate(x, y):\n    result = x + y\n    return result\n\nclass DataProcessor:\n    def __init__(self):\n        self.data = []' },
    { lang: 'JavaScript', code: 'async function fetchData() {\n  const response = await fetch("/api");\n  const data = await response.json();\n  return data;\n}\n\nconst array = [1,2,3].map(x => x * 2);' },
    { lang: 'SQL', code: 'SELECT users.name, orders.total\nFROM users\nINNER JOIN orders\n  ON users.id = orders.user_id\nWHERE orders.status = "completed";' },
  ];


  type CodeSnippet = { lang: string; code: string };

 const FloatingCode: React.FC<{ snippet: CodeSnippet; index: number }> = ({ snippet, index }) => {
  const startX = Math.random() * 100;
  const startY = Math.random() * 100;
  const duration = 40 + Math.random() * 30; // hər biri fərqli sürət
  const delay = Math.random() * 10;         // təsadüfi başlanğıc

  return (
    <div
      className="absolute text-xs font-mono opacity-20 pointer-events-none whitespace-pre select-none animate-float"
      style={{
        left: `${startX}%`,
        top: `${startY}%`,
        maxWidth: '250px',
        transform: 'translate(-50%, -50%)',
        animationDuration: `${duration}s`,
        animationDelay: `${delay}s`,
      }}
    >
      <div className={`${isDark ? 'text-blue-400' : 'text-blue-600'} mb-1 font-bold`}>
        {snippet.lang}
      </div>
      {snippet.code}
    </div>
  );
};




  return (
    <div className={`min-h-screen w-full overflow-hidden relative ${isDark ? 'bg-gray-900' : 'bg-gray-50'} transition-colors duration-500`}>
      {/* Custom Cursor */}
   
      
      {/* Floating Code Background */}
      <div className="absolute inset-0 overflow-hidden">
        {codeSnippets.map((snippet, index) => (
          <FloatingCode key={index} snippet={snippet} index={index} />
        ))}
      </div>

      {/* Theme Toggle */}
      <button
        onClick={() => setIsDark(!isDark)}
        className={`fixed top-8 right-8 p-3 rounded-full ${
          isDark ? 'bg-gray-800 text-yellow-400' : 'bg-white text-gray-800'
        } shadow-lg hover:scale-110 transition-all z-40`}
      >
        {isDark ? <Sun size={24} /> : <Moon size={24} />}
      </button>

         {/* Layihələrə keçid düyməsi */}
          <button
            onClick={() => navigate("/projects")}
      className={`fixed top-8 left-8 p-3 rounded-full ${
          isDark ? 'bg-gray-800 text-yellow-400' : 'bg-white text-gray-800'
        } shadow-lg hover:scale-110 transition-all z-40`}
      >
            Layihələrim
          </button>

      {/* Main Content */}
      <div className="relative z-10 flex items-center justify-center min-h-screen px-4">
        <div className="text-center max-w-4xl mx-auto">
          {/* Name */}
          <h1 className={`text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-bold mb-6 ${
            isDark ? 'text-white' : 'text-gray-900'
          } tracking-tight`}>
            Babək Teymurov
          </h1>

          {/* Subtitle */}
          <div className={`text-xl sm:text-2xl md:text-3xl mb-12 ${
            isDark ? 'text-gray-400' : 'text-gray-600'
          } font-light`}>
            Mobil tətbiq • Vebsayt • Desktop • Süni intellekt • Bot
          </div>

          {/* Decorative Line */}
          <div className="w-32 h-1 bg-gradient-to-r from-purple-500 to-pink-500 mx-auto mb-12 rounded-full" />
   
          {/* Contact Section */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 flex-wrap">
            {/* Instagram */}
            <a
              href="https://instagram.com/websaytim"
              target="_blank"
              rel="noopener noreferrer"
              className={`flex items-center gap-3 px-6 py-3 rounded-full ${
                isDark 
                  ? 'bg-gradient-to-r from-purple-600 to-pink-600 text-white' 
                  : 'bg-gradient-to-r from-purple-500 to-pink-500 text-white'
              } hover:scale-105 transition-all shadow-lg hover:shadow-xl`}
            >
              <Instagram size={24} />
              <span className="font-medium">websaytim</span>
            </a>

            {/* WhatsApp */}
            <a
              href="https://wa.me/994773192115"
              target="_blank"
              rel="noopener noreferrer"
              className={`flex items-center gap-3 px-6 py-3 rounded-full ${
                isDark 
                  ? 'bg-green-600 text-white' 
                  : 'bg-green-500 text-white'
              } hover:scale-105 transition-all shadow-lg hover:shadow-xl`}
            >
              <MessageCircle size={24} />
              <span className="font-medium">WhatsApp</span>
            </a>

            {/* Phone */}
            <a
              href="tel:+994773192115"
              className={`flex items-center gap-3 px-6 py-3 rounded-full ${
                isDark 
                  ? 'bg-blue-600 text-white' 
                  : 'bg-blue-500 text-white'
              } hover:scale-105 transition-all shadow-lg hover:shadow-xl`}
            >
              <Phone size={24} />
              <span className="font-medium">+994 77 319 21 15</span>
            </a>
          </div>

          {/* Animated Dots */}
          <div className="flex justify-center gap-3 mt-16">
            {[0, 1, 2].map((i) => (
              <div
                key={i}
                className="w-2 h-2 rounded-full bg-purple-500 animate-pulse"
                style={{ animationDelay: `${i * 0.2}s` }}
              />
            ))}
          </div>
        </div>
      </div>

      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-purple-900/10 pointer-events-none" />
    </div>
  );
};

export default Portfolio;